import { render, staticRenderFns } from "./BeltsSelectStripes.vue?vue&type=template&id=c5001aea&scoped=true"
import script from "./BeltsSelectStripes.vue?vue&type=script&lang=js"
export * from "./BeltsSelectStripes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5001aea",
  null
  
)

export default component.exports